import React from "react";
import { ThemeProvider, StyledEngineProvider, createTheme } from "@mui/material/styles";
import { createpaletteOptions, theme as akordTheme } from "../../theme/mui";

type ThemeWrapperProps = {
  darkMode: boolean;
};

const ThemeWrapper: React.FC<React.ReactNode & ThemeWrapperProps> = ({ children, darkMode }) => {
  const akordPalette = createpaletteOptions(darkMode);
  let mergedPalettes = akordPalette;
  const theme = createTheme(akordTheme(darkMode, mergedPalettes));

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeWrapper;
